import { convertHtmlStringToElements } from "../../../js/utils/helper/helper";
import OverlayTeaserContent from "./overlay-teaser-content/overlay-teaser-content";
import { EVENTS } from "../../../js/constants";

class OverlayTeaser {
  /**
   * @param {HTMLElement} element - OverlayTeaser element
   */
  constructor(element) {
    this.element = element;

    this.config = {
      attributes: {
        api_url: "data-api-url",
      },
      selectors: {
        content: ".js-OverlayTeaser-content",
      },
      classes: {
        hidden: "is-hidden",
      },
    };

    this._fetchContent();
  }

  /**
   * fetches content from API endpoint
   *
   * @private
   */
  async _fetchContent() {
    const apiUrl = this.element.getAttribute(this.config.attributes.api_url);

    if (apiUrl) {
      try {
        const response = await fetch(apiUrl, {
          method: "POST",
        });
        const content = await response.text();

        const elements = convertHtmlStringToElements(content);
        this.element.append(elements);

        this._initContent();
      } catch (err) {
        // error
      }
    }
  }

  /**
   * inits content
   *
   * @private
   */
  _initContent() {
    const el = this.element.querySelector(this.config.selectors.content);

    if (el) {
      this.element.dispatchEvent(
        new CustomEvent(EVENTS.OVERLAY_INIT, { bubbles: true })
      );

      this.element.classList.remove(this.config.classes.hidden);
      this.content = new OverlayTeaserContent(el);
    }
  }
}

export default OverlayTeaser;
